import { useForm } from 'react-hook-form';
import ButtonLoader from 'ui/components/button-loader/ButtonLoader';
import BasicSelect from 'ui/form-fields/basic-fields/select/BasicSelect';
import { mergeData } from 'ui/form-utils';

import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Grid } from '@mui/material';

import { defaultValues, FormValues, getValidationSchema } from './validation-schema';

var opts = [...Array(10).keys()].filter((i) => i > 0).map((i) => ({ id: i, name: `${i} Day${i > 1 ? 's' : ''}` }));

opts.unshift({ id: 0, name: 'Immediate' });

export interface PaymentusSettingsFormProps {
  isLoading: boolean;
  onFormSubmit: (values: FormValues) => void;
  onFormCancel?: () => void;
  defaults?: FormValues;
}

export default function PaymentusSettingsForm(props: PaymentusSettingsFormProps) {
  const { onFormSubmit, isLoading, defaults, onFormCancel } = props;

  const { handleSubmit, control } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: mergeData(defaultValues, defaults || {}),
    resolver: yupResolver(getValidationSchema()),
  });

  const onSubmit = (data: FormValues) => {
    onFormSubmit(data);
  };

  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <Grid container columnSpacing={4} spacing={4}>
        <Grid item xs={12}>
          <BasicSelect collection={opts} label="Days" inputName="days" control={control} />
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            {onFormCancel && (
              <Box mx={2}>
                <Button
                  variant="outlined"
                  disableElevation
                  onClick={() => {
                    onFormCancel();
                  }}
                >
                  Cancel
                </Button>
              </Box>
            )}
            <Button type="submit" variant="contained" color="primary" disabled={isLoading} disableElevation>
              <ButtonLoader isActive={isLoading} />
              Save
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}
